import React from "react";
import cx from "classnames";
import { Button } from "components/Button";
import { ReactComponent as ChevronDown } from "assets/icons/arrow-down-1.svg";
import { useDispatch, useIsLoggedIn } from "hooks";
import { setModal } from "utilities/UI/uiSlice";
import { usePickems } from "hooks/firestore";
import type {
  PickemsContest,
  PickemsEntry,
} from "hooks/firestore/pickems/types";
import { navigate } from "utilities/navigate";
import TrashIconButton from "./TrashIconButton";
import * as styles from "./PickSlip.module.scss";

type PickSlipFooterActionProps = {
  contest: PickemsContest;
  entry: PickemsEntry;
  existingPickCount: number;
  canMakePick: boolean;
};

const PickSlipFooterAction = ({
  contest,
  entry,
  existingPickCount,
  canMakePick,
}: PickSlipFooterActionProps) => {
  const isLoggedIn = useIsLoggedIn();
  const { props, actions } = usePickems();
  const dispatch = useDispatch();
  const picksAccepted = !!props.pickAcceptedId;

  if (!isLoggedIn) {
    return (
      <>
        <TrashIconButton onClick={() => actions.clearPicks()} />
        <Button
          className={styles.button}
          size={`md`}
          onClick={() => {
            dispatch(setModal("signIn"));
          }}
        >
          Log In To Pick
        </Button>
      </>
    );
  }

  if (props.confirmContestId && props.confirmContestId === contest.id) {
    const buttonText = picksAccepted
      ? "View Lobby"
      : existingPickCount > 0
        ? "Confirm Changes"
        : "Confirm Picks";

    return (
      <>
        {picksAccepted ? (
          <TrashIconButton onClick={() => actions.clearPicks()} />
        ) : (
          <Button
            variant={`blurred`}
            className={cx(styles.iconButton, styles.back)}
            onClick={() => actions.updatePickslip({ confirmContestId: null })}
          >
            <ChevronDown />
          </Button>
        )}
        <Button
          className={styles.button}
          variant={picksAccepted ? "primary" : "warning"}
          size={`md`}
          onClick={
            picksAccepted
              ? () => navigate("/pickems/")
              : () => actions.submitPicks({ contest, entry })
          }
          disabled={props.isLoading}
          loading={props.isLoading}
        >
          {buttonText}
        </Button>
      </>
    );
  }

  return (
    <>
      <TrashIconButton onClick={() => actions.clearPicks()} />
      <Button
        className={styles.button}
        size={`md`}
        disabled={!canMakePick || props.isLoading}
        loading={props.isLoading}
        onClick={() => actions.submitPicks({ contest, entry })}
      >
        {existingPickCount > 0 ? "Make Changes" : "Submit Picks"}
      </Button>
    </>
  );
};

export default PickSlipFooterAction;
